// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__zKzAx","text":"styles_text__apZro"};